import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const featuredArticles = articles.filter((a) => a.isFeatured);
  const recentArticles = articles.filter((a) => !a.isFeatured).slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-500 text-sm">
              最新黄瓜种植技术与行业动态
            </p>
          </div>
          <Link
            to="/category/zhongzhi-jishu"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-48 h-44 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[10px] md:text-xs text-primary-600 bg-primary-100 px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
                      {article.categoryName}
                    </span>
                    <span className="text-[10px] md:text-xs text-foreground-400 whitespace-nowrap">
                      {article.readTime} 分钟阅读
                    </span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.summary}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.author}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.publishDate}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {article.viewCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mb-6">
          <h3 className="font-heading font-semibold text-lg text-foreground-800 mb-4">
            最新发布
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {recentArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className="h-36 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <span className="text-[10px] text-primary-600 bg-primary-100 px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <h4 className="font-heading font-semibold text-foreground-900 text-sm mt-2 mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h4>
                  <div className="flex items-center gap-2 text-[11px] text-foreground-400">
                    <span>{article.publishDate}</span>
                    <span>·</span>
                    <span>{article.readTime}分钟阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="text-center sm:hidden">
          <Link
            to="/category/zhongzhi-jishu"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}